import type { SerializedSongPublish } from 'fym-shared/src/music24/songPublish';

export interface WaitingUpload {
  title: string;
  publishAt: string | null;
}

/** The SoundCloud uploads that wait for their time, the soonest first (design a4). */
export function waitingSoundCloudUploads(publishes: SerializedSongPublish[] | undefined): WaitingUpload[] {
  return (publishes ?? [])
    .filter((one) => one.channel === 'soundcloud' && (one.status === 'waiting' || one.status === 'scheduled'))
    .sort((left, right) => (left.publishAt ?? '').localeCompare(right.publishAt ?? ''))
    .map((one) => ({ title: one.title ?? '', publishAt: one.publishAt }));
}
